import { type JSX } from 'react/jsx-runtime';

export const GoalsCardIllustrationDark = (): JSX.Element => (
	<svg
		height="128"
		width="100%"
		fill="none"
		preserveAspectRatio="xMinYMin slice"
		role="presentation"
		viewBox="0 0 335 128"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_8794_200596)">
			<path fill="#2B2C2F" d="M0 8a8 8 0 0 1 8-8h319a8 8 0 0 1 8 8v120H0V8Z" />
			<path stroke="#F0F1F2" strokeWidth={1.573} d="M92.953 19.417h5.889v5.745h-5.889z" />
			<path
				fill="#fff"
				fillRule="evenodd"
				d="M95.605 20.145c.16-.297.422-.298.583 0l2.215 4.104c.16.297.014.54-.329.54h-4.356c-.343 0-.49-.242-.329-.54l2.216-4.104Zm.072 2.97a.314.314 0 0 0 .44 0 .302.302 0 0 0 .09-.215v-1.525a.302.302 0 0 0-.09-.216.314.314 0 0 0-.44 0 .302.302 0 0 0-.092.216v1.524c0 .081.033.159.092.216Zm0 .915a.314.314 0 0 0 .44 0 .302.302 0 0 0 0-.431.314.314 0 0 0-.44 0 .302.302 0 0 0 0 .43Z"
				clipRule="evenodd"
			/>
			<rect width={198.71} height={35} x={50} y={15.004} fill="#1F1F21" rx={1.129} />
			<path
				fill="#1868DB"
				fillRule="evenodd"
				d="M67.947 26.178a6.325 6.325 0 1 0 0 12.65 6.325 6.325 0 0 0 0-12.65Zm-7.785 6.326a7.785 7.785 0 1 1 15.57 0 7.785 7.785 0 0 1-15.57 0Zm7.785-2.433a2.433 2.433 0 1 0 0 4.865 2.433 2.433 0 0 0 0-4.865Zm-3.892 2.433a3.893 3.893 0 1 1 7.785 0 3.893 3.893 0 0 1-7.785 0Z"
				clipRule="evenodd"
			/>
			<path fill="#303134" d="M87.022 29.504h79v6h-79z" />
			<rect width={59.871} height={15.871} x={177.877} y={24.568} fill="#D3F1A7" rx={7.935} />
			<rect
				width={59.871}
				height={15.871}
				x={177.877}
				y={24.568}
				stroke="#B3DF72"
				strokeWidth={1.129}
				rx={7.935}
			/>
			<path fill="#4C6B1F" d="M186.812 30.504h42v4h-42z" />
			<path
				fill="#CECFD2"
				d="M91.92 75.234c-4.352-4.156-2.913-1.102-.392 1.55-20.557.95-25.21 3.524-23.285-19.885.003-2.924-1.378 2.203-.929 2.787.504.487-.659.71-.316 2.153-1.782 17.008 4.612 18.392 21.106 16.168 6.224-.108.673.65.095 2.996.437.062 4.814-2.258 5.51-3.423-.397-.811-.912-1.973-1.79-2.349v.003ZM90.92 112.234c-4.352-4.156-2.913-1.101-.392 1.549-20.557.951-25.21 3.525-23.285-19.884.003-2.924-1.378 2.204-.929 2.787.504.487-.659.71-.316 2.153-1.782 17.008 4.612 18.392 21.106 16.168 6.224-.108.673.65.095 2.996.437.062 4.814-2.258 5.51-3.423-.397-.811-.912-1.973-1.79-2.348v.002Z"
			/>
			<mask id="path-11-inside-1_8794_200596" fill="#fff">
				<rect width={7.58} height={8.026} x={123.584} y={60.978} rx={1.097} />
			</mask>
			<rect
				width={7.58}
				height={8.026}
				x={123.584}
				y={60.978}
				stroke="#F0F1F2"
				strokeWidth={3.451}
				mask="url(#path-11-inside-1_8794_200596)"
				rx={1.097}
			/>
			<path
				fill="#fff"
				fillRule="evenodd"
				d="M127.076 62.64c.163-.326.429-.328.593 0l2.25 4.5c.163.326.014.592-.334.592h-4.425c-.348 0-.497-.265-.334-.592l2.25-4.5Zm.073 3.257c.059.063.14.098.223.098a.308.308 0 0 0 .224-.098.345.345 0 0 0 .092-.237v-1.672a.345.345 0 0 0-.092-.236.308.308 0 0 0-.224-.098.307.307 0 0 0-.223.098.345.345 0 0 0-.092.236v1.672c0 .089.033.174.092.237Zm0 1.003c.059.063.14.098.223.098a.308.308 0 0 0 .224-.098.345.345 0 0 0 .092-.236.345.345 0 0 0-.092-.237.308.308 0 0 0-.224-.098.307.307 0 0 0-.223.098.345.345 0 0 0-.092.237c0 .088.033.173.092.236Z"
				clipRule="evenodd"
			/>
			<rect width={189.742} height={34} x={96.711} y={57.002} fill="#1F1F21" rx={1.097} />
			<path
				fill="#9E4C00"
				fillRule="evenodd"
				d="M114.144 67.857a6.144 6.144 0 1 0 0 12.29 6.144 6.144 0 0 0 0-12.29Zm-7.562 6.145a7.562 7.562 0 1 1 15.125 0 7.562 7.562 0 0 1-15.125 0Zm7.562-2.363a2.363 2.363 0 1 0 0 4.726 2.363 2.363 0 0 0 0-4.726Zm-3.781 2.363a3.781 3.781 0 1 1 7.562 0 3.781 3.781 0 0 1-7.562 0Z"
				clipRule="evenodd"
			/>
			<path fill="#303134" d="M132.674 71.002h84v6h-84z" />
			<rect width={49.1} height={15.355} x={227.093} y={66.324} fill="#693200" rx={7.677} />
			<rect
				width={49.1}
				height={15.355}
				x={227.093}
				y={66.324}
				stroke="#9E4C00"
				strokeWidth={1.097}
				rx={7.677}
			/>
			<path fill="#9E4C00" d="M235.258 72h33v4h-33z" />
			<mask id="path-18-inside-2_8794_200596" fill="#fff">
				<rect width={7.58} height={8.026} x={123.584} y={101.979} rx={1.097} />
			</mask>
			<rect
				width={7.58}
				height={8.026}
				x={123.584}
				y={101.979}
				stroke="#F0F1F2"
				strokeWidth={3.451}
				mask="url(#path-18-inside-2_8794_200596)"
				rx={1.097}
			/>
			<path
				fill="#fff"
				fillRule="evenodd"
				d="M127.076 103.639c.163-.325.429-.327.593 0l2.25 4.501c.163.326.014.592-.334.592h-4.425c-.348 0-.497-.265-.334-.592l2.25-4.501Zm.073 3.258a.31.31 0 0 0 .223.098.31.31 0 0 0 .224-.098.347.347 0 0 0 .092-.237v-1.672a.342.342 0 0 0-.092-.236.307.307 0 0 0-.224-.098.306.306 0 0 0-.223.098.342.342 0 0 0-.092.236v1.672c0 .089.033.174.092.237Zm0 1.003c.059.063.14.098.223.098a.307.307 0 0 0 .224-.098.346.346 0 0 0 .092-.236.347.347 0 0 0-.092-.237.307.307 0 0 0-.224-.098.306.306 0 0 0-.223.098.347.347 0 0 0-.092.237c0 .088.033.173.092.236Z"
				clipRule="evenodd"
			/>
			<rect width={189.742} height={34} x={96.711} y={98.002} fill="#1F1F21" rx={1.097} />
			<path
				fill="#4C6B1F"
				fillRule="evenodd"
				d="M114.144 108.857a6.145 6.145 0 1 0 .001 12.289 6.145 6.145 0 0 0-.001-12.289Zm-7.562 6.145a7.563 7.563 0 1 1 15.125 0 7.563 7.563 0 0 1-15.125 0Zm7.562-2.363a2.363 2.363 0 1 0 0 4.726 2.363 2.363 0 0 0 0-4.726Zm-3.781 2.363a3.781 3.781 0 1 1 7.562 0 3.781 3.781 0 0 1-7.562 0Z"
				clipRule="evenodd"
			/>
			<path fill="#303134" d="M132.674 112.002h84v6h-84z" />
			<rect width={49.1} height={15.355} x={227.093} y={107.324} fill="#5D1F1A" rx={7.677} />
			<rect
				width={49.1}
				height={15.355}
				x={227.093}
				y={107.324}
				stroke="#AE2E24"
				strokeWidth={1.097}
				rx={7.677}
			/>
			<path fill="#AE2E24" d="M235.258 113h33v4h-33z" />
			<path
				fill="#CECFD2"
				d="M55.713 27a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6h-12a6 6 0 0 1-6-6V27Z"
			/>
			<path fill="#1F1F21" d="M70.064 33a2.352 2.352 0 1 1-4.703 0 2.352 2.352 0 0 1 4.703 0Z" />
			<path
				fill="#1F1F21"
				fillRule="evenodd"
				d="M67.713 39.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125ZM71.815 33a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.203 0Z"
				clipRule="evenodd"
			/>
		</g>
		<defs>
			<clipPath id="clip0_8794_200596">
				<path fill="#fff" d="M0 8a8 8 0 0 1 8-8h319a8 8 0 0 1 8 8v120H0V8Z" />
			</clipPath>
		</defs>
	</svg>
);
